module.exports = __webpack_public_path__ + "static/meeting-e772d612ef76639804a28d813ba04800.png";